import NewsDetail from './newsdetail';

export default NewsDetail;